module.exports = __webpack_public_path__ + "static/media/Profile.82e1f46c.md";